import { AccessViaEnum } from "../enums/access-via.enum";

export type AccessType = "EMAIL" | "LOGON" | "API";

export type BackendAccessType = "USER_ACCOUNT" | "SERVICE_ACCOUNT";

export interface GuardableAccount {
  isSystemic?: boolean | null;
  accessTypes?: ReadonlyArray<BackendAccessType> | null;
  accessVia?: AccessType;
  email?: string;
  logon?: string;
}

/** Conta sistêmica quando `accessTypes` inclui `SERVICE_ACCOUNT`. */
export function mapIsSystemicFromAccessTypes(
  accessTypes?: ReadonlyArray<BackendAccessType> | null,
): boolean | undefined {
  if (accessTypes == null) {
    return undefined;
  }
  return accessTypes.includes("SERVICE_ACCOUNT");
}

/** Inibe ações de risco quando a conta é sistêmica ou o indicador está ausente. */
export function shouldInhibitRiskActions(account?: GuardableAccount | null): boolean {
  return account?.isSystemic !== false;
}

/** Conta híbrida: pessoa + serviço (`USER_ACCOUNT` e `SERVICE_ACCOUNT`). */
export function isHybridAccount(account?: GuardableAccount | null): boolean {
  const types = account?.accessTypes;
  if (!types?.length) {
    return false;
  }
  return types.includes("USER_ACCOUNT") && types.includes("SERVICE_ACCOUNT");
}

/**
 * Editar: conta comum ou híbrida.
 * Conta só-sistema e fail-safe (tipo ausente) não exibem editar.
 */
export function canEditAccount(account?: GuardableAccount | null): boolean {
  if (!account) {
    return false;
  }
  if (account.isSystemic === false) {
    return true;
  }
  if (account.isSystemic !== true) {
    return false;
  }
  return isHybridAccount(account);
}

/** Resolve o tipo de "Acesso via" para exibição. */
export function resolveAccessVia(account?: GuardableAccount | null): AccessType {
  if (account?.isSystemic === true) {
    return "API";
  }

  if (account?.accessVia) {
    return account.accessVia;
  }

  return account?.email ? "EMAIL" : "LOGON";
}

/** Rótulo de exibição do tipo de acesso. */
export function getAccessViaLabel(type: AccessType): string {
  return AccessViaEnum[type] ?? type;
}
